import { el, setAttr } from 'redom';

import { fromEvent } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';

import { stringToSVG } from 'utilities';

import SearchIconString from 'assets/images/search-icon.svg?raw';
import ClearInputButtonIconString from 'assets/images/clear-input-button-icon.svg?raw';

const SearchIcon = stringToSVG(SearchIconString);
const ClearInputButtonIcon = stringToSVG(ClearInputButtonIconString);

setAttr(SearchIcon, {
  class: 'application-subtle-icon'
});

class SimpleSearchControl {

  constructor(options) {

    this.placeholder = options.placeholder;
    this.onChange = options.onChange;
    this.onClear = options.onClear;
    this.debounceDelay = 300;

    if (typeof options.debounceDelay === 'number') {
      this.debounceDelay = options.debounceDelay;
    }

    this.input = null;
    this.clearButton = null;

    this.initializeInput();
    this.initializeClearButton();

    this.search$ = fromEvent(this.input, 'input').pipe(map(event => event.target.value),
      debounceTime(this.debounceDelay));

    this.search$.subscribe(value => this.doHandleInputChange(value));

    const children = [];

    if (options.noIcon !== true) {
      children.push(SearchIcon.cloneNode(true));
    }

    children.push(this.input, this.clearButton);

    this.el = el('.simple-search-control-main.simple-search-control-native.empty', children, {
      onclick: this.handleMainElementClick.bind(this),
      onClick: this.handleMainElementClick.bind(this)
    });

  }

  initializeInput() {

    this.input = el('input.simple-search-control-input.simple-search-input', {
      type: 'text',
      autoComplete: 'off',
      placeholder: this.placeholder
    });

  }

  initializeClearButton() {

    this.clearButton = el('button.simple-search-control-clear-button', ClearInputButtonIcon.cloneNode(true), {
      type: 'button',
      style: {
        display: 'none'
      }
    });

    this.clearButton.addEventListener('click', this.handleClearButtonClick.bind(this));

  }

  handleInputChange(event) {

    event.stopPropagation();

    this.doHandleInputChange(event.target.value.trim());

    return false;

  }

  handleClearButtonClick(event) {

    event.stopPropagation();

    this.clearInputText();

    return false;

  }

  handleMainElementClick(event) {

    event.stopPropagation();

    this.tryFocusInput(event.target);

    return false;

  }

  showClearButton() {

    this.el.classList.remove('empty');
    setAttr(this.clearButton, {
      style: {
        display: 'flex'
      }
    });

  }

  hideClearButton() {

    this.el.classList.add('empty');
    setAttr(this.clearButton, {
      style: {
        display: 'none'
      }
    });

  }

  clearInputText() {

    setAttr(this.input, { value: '' });

    this.hideClearButton();

    this.input.focus();

    this.onClear();

  }

  doHandleInputChange(value) {

    const valueLength = value.length;

    if (valueLength > 0) {
      this.showClearButton();
    } else {
      this.hideClearButton();
    }

    this.onChange(value);

  }

  tryFocusInput(target) {

    if (target === this.input) {
      return;
    }

    this.input.focus();

  }

  // Shows a value set from outside without reporting it back as a change.
  setValue(value) {

    setAttr(this.input, { value });

    if (value.length > 0) {
      this.showClearButton();
    } else {
      this.hideClearButton();
    }

  }

  focus() {

    this.input.focus();

  }

}

export default SimpleSearchControl;